import BookingImporter from './BookingImporter'
import UserImporter from './UserImporter'

export default {
  BookingImporter,
  UserImporter
}
